import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgFavorite = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M18.027 5.538a5.078 5.078 0 00-1.111-1.617 5.183 5.183 0 00-3.64-1.48A5.216 5.216 0 0010 3.595a5.216 5.216 0 00-3.275-1.154 5.182 5.182 0 00-3.641 1.48A5.048 5.048 0 001.562 7.53c0 .65.133 1.328.397 2.017.22.576.537 1.174.941 1.778.641.955 1.522 1.95 2.616 2.96a29.236 29.236 0 003.683 2.877l.463.297c.205.131.469.131.674 0l.463-.296a29.601 29.601 0 003.683-2.877c1.094-1.01 1.975-2.006 2.616-2.961a8.936 8.936 0 00.941-1.778c.264-.69.396-1.367.396-2.017a4.972 4.972 0 00-.408-1.99zM10 15.914s-6.953-4.456-6.953-8.385c0-1.99 1.646-3.604 3.678-3.604 1.427 0 2.666.797 3.275 1.961a3.688 3.688 0 013.275-1.96c2.032 0 3.678 1.612 3.678 3.603 0 3.93-6.953 8.385-6.953 8.385z" />
    </Icon>
  );
};

export default SvgFavorite;
